import styled from 'styled-components';

// The CSS reset strips lists, bold text and link underlines, which the legal texts rely on to stay readable.
export const SLegalText = styled.div`
    ul {
        margin-bottom: 2rem;
        padding-left: 2rem;
        list-style: disc;
    }

    li {
        margin-bottom: 0.5rem;
    }

    strong {
        font-weight: bold;
    }

    a {
        text-decoration: underline;
    }
`;
